import { assertExhaustiveSwitch } from '@paragon/utilities';

import {
  ComponentDesignAnalysisState,
  LongRunningAnalysisStage,
} from '../../../../store/slices/longRunningOperationsSlice';
import { ProgressCategory } from '../ComponentDesignListItem';

function describeAnalysisStage(stage: LongRunningAnalysisStage): string {
  switch (stage) {
    case 'waiting':
      return 'waiting';
    case 'fetching':
      return 'fetching component design';
    case 'analyzing':
      return 'analyzing';
    case 'upgrading-and-analyzing':
      return 'upgrading and analyzing';
    case 'finished':
      return 'successfully analyzed';
    case 'failed':
      return 'unable to analyze';
    default:
      assertExhaustiveSwitch(stage);
  }
}

function makeHumanReadable(analysisStageString: string) {
  return `${analysisStageString[0].toUpperCase() + analysisStageString.substring(1)}...`;
}

export function describeAnalysisState(analysisState: ComponentDesignAnalysisState): [ProgressCategory, string] {
  const stageDescription = describeAnalysisStage(analysisState.currentStage);
  switch (analysisState.currentStage) {
    case 'waiting':
      return ['waiting', makeHumanReadable(stageDescription)];

    case 'finished':
      return [
        'finished',
        analysisState.recordedMessages.some((message) => message.type === 'error')
          ? 'Analyzed with errors.'
          : analysisState.recordedMessages.some((message) => message.type === 'warning')
            ? 'Analyzed with warnings.'
            : 'Successfully analyzed.',
      ];

    case 'failed': {
      const errorMessages = analysisState.recordedMessages.filter((message) => message.type === 'error');
      if (errorMessages.length > 0) {
        const failedStageDescription = describeAnalysisStage(errorMessages[0].stage);
        return ['finished', `Error while ${failedStageDescription}.`];
      }

      return ['finished', `Unknown error—analysis did not complete.`];
    }

    default:
      return ['working', makeHumanReadable(stageDescription)];
  }
}
